import type { ElementType, ReactNode } from 'react';
import styles from './Typography.module.css';
export type TextVariant =
  | 'hero'
  | 'heading'
  | 'title'
  | 'subheading'
  | 'body'
  | 'small'
  | 'eyebrow'
  | 'brand'
  | 'intro'
  | 'metric'
  | 'quote'
  | 'caption'
  | 'diagram'
  | 'diagramLabel'
  | 'compactMetric'
  | 'client'
  | 'cardTitle'
  | 'tab'
  | 'fieldLabel'
  | 'tag'
  | 'metricLabel'
  | 'button';
type Props = {
  as?: ElementType;
  variant?: TextVariant;
  tone?: 'default' | 'muted' | 'inverse' | 'inherit';
  children: ReactNode;
  id?: string;
  htmlFor?: string;
};
export function Typography({
  as: Tag = 'p',
  variant = 'body',
  tone = 'default',
  children,
  id,
  htmlFor,
}: Props) {
  return (
    <Tag className={`${styles.text} ${styles[variant]} ${styles[tone]}`} id={id} htmlFor={htmlFor}>
      {children}
    </Tag>
  );
}
